<template>
  <div class="main">
    <div class="back">
      88.888
    </div>
    <div class="front">
<!--      {{ (value ? value.slice(0, 2) : '00')}}.{{(value ? value.slice(2, 5) : '000')}}-->
       {{(value && value >= 10 ? '' : (value ? 0 : ''))}}{{ (value ? value : '00.000')}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: ['value'],
  mounted () {},
  methods: {}
}
</script>

<style scoped>
.main {
  width: 100%;
  background: #FFF4DC;
  height: 50px;
  border: 2px solid;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.back {
  position: absolute;
  opacity: 0.1;
  font-family: DSEG7 !important;
  font-size: 30px;
}
.front {
  /* z-index: 2; */
  position: absolute;
  font-family: DSEG7 !important;
  font-size: 30px;
}
</style>
